import React from 'react';
import { Section } from 'components/shared';

import loadable from '@loadable/component';
const IconBlock = loadable(() =>
  import('components/components/organisms/IconBlock'),
);
const MapBlock = loadable(() =>
  import('components/components/organisms/MapBlock'),
);

const CommunityServices = ({ fields, rendering }) => {
  const data = fields.value[0];
  if (!data) {
    return null;
  }

  const items = data.subItems || [];
  const title = data.title;
  const copy = data.copy;
  const mapview = data.poiMap;
  const zoomLevel = data.zoomLevel;

  const filteredItems = items.filter((item) => item.title);

  if (filteredItems.length < 4 && !mapview) {
    return null;
  }
  const latLongFilter = items.filter((item) => item.latitude && item.longitude);
  return (
    <Section id={'whatsnearby'} tabIndex='-1' className='focus:outline-none'>
      {(!mapview || (mapview && latLongFilter.length === 0)) && (
        <IconBlock items={filteredItems} title={title} />
      )}
      {mapview && (
        <MapBlock
          items={items}
          title={title}
          copy={copy}
          zoomLevel={zoomLevel}
        />
      )}
    </Section>
  );
};

export default CommunityServices;
